import APIclient from "API/Client";
import { GetOrgId } from "utility";

export const fetchCompanyExpenseAndBalance = () => {
  return APIclient.getData(`/api/v1/org/card/wallet/orgWallet?organisation_id=${GetOrgId()}`);
};
